<template>
  <component :is="layout" />
</template>
<script setup>
import { useI18n } from 'vue-i18n';
import { useSeoLanguageSync } from '@/composables/useSeoLanguageSync';

// Initialize SEO language sync
const i18n = useI18n();
useSeoLanguageSync(i18n);
</script>

<script>
import EmptyLayout from '@/layouts/EmptyLayout.vue';
import RegLayout from '@/layouts/RegLayout.vue';
import WebLayout from '@/layouts/WebLayout.vue';
import WebLayout2 from '@/layouts/WebLayout2.vue';
import ProfileLayout from '@/layouts/ProfileLayout.vue';
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import AgentLayout from '@/layouts/AgentLayout.vue';
import RoomAgentLayout from '@/layouts/RoomAgentLayout.vue';

export default {
  name: "App",
  data() {
    return {
      layout: null,
    };
  },
  components: {
    EmptyLayout,
    RegLayout,
    WebLayout,
    WebLayout2,
    ProfileLayout,
    DashboardLayout,
    AgentLayout,
    RoomAgentLayout,
  },
  watch: {
    $route(to) {
      if (to.meta.layout !== undefined) {
        this.layout = to.meta.layout
      } else {
        this.layout = "EmptyLayout"
      }
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  overflow-x: hidden;
  max-width: 100vw;
  width: 100%;
}

#app {
  overflow-x: hidden;
  max-width: 100vw;
  width: 100%;
}
</style>